import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@Core/services/auth.service';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
    standalone: false,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [NgbTooltipConfig]
})
export class AppComponent {
    public loading = false;

    constructor(public authService: AuthService,
        private router: Router,
        private tooltipConfig: NgbTooltipConfig) {
        tooltipConfig.openDelay = 1000;
        tooltipConfig.container = 'body';

        // Eagerly start loading auth state from the server cookie.
        // After a full page reload (e.g. area change), this ensures
        // the session is restored before route guards evaluate.
        this.authService.initializeAuth();
    }
}

